import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { MultipleCellContentComponent } from '../pages/custom-components/multiple-cell-content.component';
import { ExpandableCellContentComponent } from '../pages/custom-components/expandable-cell-content/expandable-cell-content.component';
import { NotesCellComponent } from '../pages/custom-components/notes-cell.component';
import { MathService } from './math.service';
import { DynamicRendererComponent } from '../pages/custom-components/dynamic-renderer/dynamic-renderer.component';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  openBooking$ = new Subject<string>();

  private moduleName: string = "Booking";

  url = environment.endpoint + "/api/" + this.moduleName;

  constructor(
    private http: HttpClient,
    private mathService: MathService,
  ) {
  }

  
  getHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      })
    };
  }

  get(id:any) {
    const url = this.url + "/" + (id != undefined ? id : '');
    return this.http.get(url, this.getHeaders());
  }

  sendBookingOrder(bookingId:any) {
    const url = this.url + "/send/order/bookingId=" + bookingId;
    return this.http.get(url, this.getHeaders());
  }

  sendConfirmation_withEmail(bookingNumber:any, email:any) {
    const url = this.url + "/send/confirmation/bookingNumber=" + bookingNumber + "&email=" + email;
    return this.http.get(url, this.getHeaders());
  }

  sendConfirmation(bookingId:any) {
    const url = this.url + "/send/confirmation/bookingId=" + bookingId;
    return this.http.get(url, this.getHeaders());
  }

  getByuserId(id: any) {
    const url = this.url + "/UserId=" + (id);
    return this.http.get(url, this.getHeaders());
  }
  getByBranchId(id: any) {
    const url = this.url + "/BranchId=" + (id);
    return this.http.get(url, this.getHeaders());
  }
  getTodayByBranchId(id: any) {
    const url = this.url + "/today/BranchId=" + (id);
    return this.http.get(url, this.getHeaders());
  }
  getByuserIdAndStatus(id: any,status: any) {
    const url = this.url + "/UserId=" + (id)+"/Status="+(status);
    return this.http.get(url, this.getHeaders());
  }
  getByBookingNumber(number: any) {
    const url = this.url + "/bookingNumber=" + (number);
    return this.http.get(url, this.getHeaders());
  }
  getByCartNumber(number: any) {
    const url = this.url + "/cart/number=" + (number);
    return this.http.get(url, this.getHeaders());
  }

  getBookingDetId(id:any) {
    const url = this.url + "/details/branch=" + (id != undefined ? id : '');
    return this.http.get(url, this.getHeaders());
  }

  getAllBookingDet() {
    const url = this.url + "/details";
    return this.http.get(url, this.getHeaders());
  }
  
  getPendingPaymentDetId(id:any) {
    const url = this.url + "/details/pending_payment/branch=" + (id != undefined ? id : '');
    return this.http.get(url, this.getHeaders());
  }
  
  getPendingPaymentCarts(branchid:any) {
    const url = this.url + "/details/pending_payment_cart/branch=" + (branchid != undefined ? branchid : '');
    return this.http.get(url, this.getHeaders());
  }
  
  getAllPendingPaymentCarts() {
    const url = this.url + "/details/pending_payment_cart";
    return this.http.get(url, this.getHeaders());
  }
  
  getAllPendingPaymentDet() {
    const url = this.url + "/details/pending_payment";
    return this.http.get(url, this.getHeaders());
  }

  getDetailsByBookingId(id: any) {
    const url = this.url + "/details/bookid=" + (id);
    return this.http.get(url, this.getHeaders());
  }
  getDetailsByBookingNumber(number: any) {
    const url = this.url + "/details/booknum=" + (number);
    return this.http.get(url, this.getHeaders());
  }

  getAll() {
    const url = this.url + "/";
    return this.http.get(url);
  }

  getAllPendingPayment(){
     const url = this.url + "/pending_payment";
    return this.http.get(url, this.getHeaders());
  }

  getPendingByBranch(id: any) {
    const url = this.url + "/pending_payment/branchId=" + (id);
    // const url = this.url + "/branchId=" + (id) + "/status=0";
    return this.http.get(url, this.getHeaders());
  }

  getPaymentHistoryByBooking(id: any) {
    const url = environment.endpoint + "/api/Payment/history/booking-id=" + (id);
    // const url = this.url + "/branchId=" + (id) + "/status=0";
    return this.http.get(url, this.getHeaders());
  }

  create(info: any) {
    console.log(info)
    const url = this.url + '/create';
    return new Promise(resolve => {
      this.http.post(url, info, this.getHeaders()).subscribe(
        response => {
          let res :any;
          res = response;          
          resolve(res)
        },
        err => {
          // console.log(err)
          resolve(err)

          // alert(JSON.stringify(err));
        }
      );

    }).catch(err => {
      console.log(err)
    })

  }

  handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError(error);
  }

  update(info: { id: string; }) {
    const url = this.url + '/' + info.id;
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  cancel(info: { id: string; }) {
    const url = this.url + '/cancel/' + info.id;
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }
  
  updateStatus(info:any) {
    const url = this.url + '/update-status';
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  complete(bookingId, userId) {
    const url = this.url + '/complete/bookingId=' + bookingId + "/userId=" + userId;
    var info:any = {};
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  delete(info: { id: string; }) {
    const url = this.url + '/' + info.id;
    return this.http.delete(url, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  Payment_complete(info:any) {
    const url = environment.endpoint + "/api/Payment/complete";
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  checkIn(info:any, userId) {
    const url = this.url + '/checkin/userId=' + userId;

    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  getRemittances(branchId : any) {
    const url = this.url + "/Remittances/BranchId=" + (branchId);
    return this.http.get(url, this.getHeaders());
  }

  StatusString(statusCode) {

      switch(statusCode) {
        case 0:
          return "Pending";
        case 1:
          return "Confirmed";
        case 2:
          return "Check-in";
        case 3:
          return "Completed";
        case 4:
          return "Cancelled";
        case 5:
          return "Payment Declined";
        case 6:
          return "Expired";
        case 7:
          return "Cancel Request";
      }
  }














  // #region Booking Tables

  Col_BranchAndRoomTypeName = {
    title: 'Branch Name',
    type: 'custom',
    width: '15%',
    renderComponent: MultipleCellContentComponent,
  }
  Col_BooknumAndBookdate = {
    title: 'Cart/Booking Number',
    type: 'custom',
    width: '15%',
    renderComponent: DynamicRendererComponent,
  }
  Col_NameAndPax = {
    title: 'Guest Name',
    type: 'custom',
    width: '15%',
    renderComponent: MultipleCellContentComponent,
  }
  Col_AmountAndPaymentType = {
    title: 'Total Price',
    width: '15%',
    type: 'custom',
    renderComponent: MultipleCellContentComponent,
  }
  Col_notes = {
    title: 'Notes',
    type: 'custom',
    class: 'notes',
    width: '10%',
    renderComponent: NotesCellComponent,
  }
  // Col_roomId = {
  //   title: 'Room',
  //   valuePrepareFunction : (rid) => {
  //     var room =  this.allRooms.find(r => {
  //       return rid == r.id;
  //     })
  //     return room ? room.roomName : '';
  //   }
  // }
  Col_BookingDate = {
    title: 'Booking Date',
    type: 'string',
    width: '10%',
  }

  Settings_Actions = {
    add: false,
    delete: false,
    edit: false,
    position: 'right',
  };
  
  table_pending = {
      actions: {
        ...this.Settings_Actions,
        custom: [
          {
            name: 'approve',
            // title: "<i class='nb-checkmark-circle'></i>",
            title: "Approve",
            class: 'approve',
          },
          {
            name: 'decline',
            // title: "<i class='nb-trash'></i>",
            title: "Decline",
            class: 'decline',
          }
        ],
      },
      columns: {
        _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
        _BookingDate: this.Col_BookingDate,
        _BooknumAndBookdate: this.Col_BooknumAndBookdate,
        _GuestDetails: this.Col_NameAndPax,
        balance: { title: 'Balance', width: '10%', type: 'string' },
        totalAmount: { title: 'Total Price', width: '10%', type: 'string' },
        notes: this.Col_notes,
      },
    }

  table_confirmed = {
    actions: {
      ...this.Settings_Actions,
      custom: [{ name: 'edit', title: "Check-In" }]
    },
    columns: {
      _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
      _BookingDate: this.Col_BookingDate,
      _BooknumAndBookdate: this.Col_BooknumAndBookdate,
      _NameAndPax: this.Col_NameAndPax,
      _AmountAndPaymentType: this.Col_AmountAndPaymentType,
      notes: this.Col_notes
    }
  }
  
  table_checkedIn = {
    actions: {
      ...this.Settings_Actions,
      custom: [{ name: 'edit', title: "Check-Out" }]
    },
    columns: {
      _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
      _BookingDate: this.Col_BookingDate,
      _BooknumAndBookdate: this.Col_BooknumAndBookdate,
      _NameAndPax: this.Col_NameAndPax,
        // roomId: this.Col_roomId,
      _AmountAndPaymentType: this.Col_AmountAndPaymentType,
      notes: this.Col_notes,
    },
  }
  
  table_confirmed_noAction = {
    actions: {
      ...this.Settings_Actions,
      custom: [{ name: 'edit', title: "Details" }]
    },
    columns: {
      _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
      _BookingDate: this.Col_BookingDate,
      _BooknumAndBookdate: this.Col_BooknumAndBookdate,
      _NameAndPax: this.Col_NameAndPax,
      _AmountAndPaymentType: this.Col_AmountAndPaymentType,
      notes: this.Col_notes
    }
  }
  
    table_checkedIn_noAction = {
      actions: {
        ...this.Settings_Actions
      },
      columns: {
        _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
        _BookingDate: this.Col_BookingDate,
        _BooknumAndBookdate: this.Col_BooknumAndBookdate,
        _NameAndPax: this.Col_NameAndPax,
          // roomId: this.Col_roomId,
        _AmountAndPaymentType: this.Col_AmountAndPaymentType,
        notes: this.Col_notes,
      }
    }
    
    table_completed = {
      actions: {
        ...this.Settings_Actions
      },
      columns: {
        _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
        _BookingDate: this.Col_BookingDate,
        _BooknumAndBookdate: this.Col_BooknumAndBookdate,
        _NameAndPax: this.Col_NameAndPax,
          // roomId: this.Col_roomId,
        _AmountAndPaymentType: this.Col_AmountAndPaymentType,
        notes: this.Col_notes,
      }
    }
  
    table_requests = {
      actions: {
        ...this.Settings_Actions,
        custom: [{ name: 'edit', title: "Cancel" }]
      },
      columns: {
        _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
        _BookingDate: this.Col_BookingDate,
        _BooknumAndBookdate: this.Col_BooknumAndBookdate,
        _NameAndPax: this.Col_NameAndPax,
        _AmountAndPaymentType: this.Col_AmountAndPaymentType,
      }
    }
    
    table_cancelled = {
      actions: {
        ...this.Settings_Actions
      },
      columns: {
        _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
        _BookingDate: this.Col_BookingDate,
        _BooknumAndBookdate: this.Col_BooknumAndBookdate,
        _NameAndPax: this.Col_NameAndPax,
          // roomId: this.Col_roomId,
        _AmountAndPaymentType: this.Col_AmountAndPaymentType,
        notes: this.Col_notes,
      }
    }
  
    table_payment = {
      actions: {
        add: false,
        delete: false,
        edit: false,
      },
      columns: {
        // _BranchAndRoomTypeName: this.Col_BranchAndRoomTypeName,
        _paymentDate: {
          title: 'Payment Date',
          type: 'string',
        },
        paymentSource: {
          title: 'Payment Source',
          type: 'string',
        },
        _referenceNumber: {
          title: 'Ref. Number',
          type: 'string',
        },
        _bookAmount: {
          title: 'Amount Paid',
          type: 'string',
        },
        convenienceFee: {
          title: 'Convenience Fee',
          type: 'string',
        },
        _cartAmount: {
          title: 'Cart Amount',
          type: 'string',
        },
        status: {
          title: 'Status',
          type: 'string',
        },
      },
    }






    
// #region Booking Tables Functions 

Process_BranchAndRoomTypeName(booking) {
      // Process Branch Merge with Roomtype Name

          const roomTypeName = booking.bookingDetails?.roomTypeName || "[Room Type Unknown]";
          const branchName = booking.bookingDetails?.branchName || "[Branch Name Unknown]";
          booking._BranchAndRoomTypeName = branchName + "||" + roomTypeName
      }
Process_CartBranchAndRoomTypeName(cartData) {
      // Process Branch Merge with Roomtype Name
          cartData._BranchAndRoomTypeName = "(" + cartData.bookings.length + (cartData.bookings.length == 1 ? " booking" : " bookings") + ")";
          cartData.bookings.forEach(b => {
            const roomTypeName = b.bookingDetails?.roomTypeName || "[Room Type Unknown]";
            const branchName = b.bookingDetails?.branchName || "[Branch Name Unknown]";
            cartData._BranchAndRoomTypeName += "||" + branchName + " - " + roomTypeName
          });
      }

Process_BooknumAndBookdate(booking) {
      // Process Booking Date, Merge with Booking Number

          var _from = new Date(booking.booking.bookFrom);
          var _to = new Date(booking.booking.bookTo);
          booking._bookFrom = _from.toDateString().substring(4,15) + "\n";
          booking._bookTo = _to.toDateString().substring(4,15) + "\n";
        
          booking._BooknumAndBookdate = booking.booking.bookingNumber + "|| Check-in: \n" + booking._bookFrom + " - " + booking._bookTo;
      }
Process_CartNBooknumsAndBookdate(cartResult) {
          cartResult._BooknumAndBookdate = cartResult.cart.cartNumber + "||";
          cartResult.bookings.forEach(b => {
            cartResult._BooknumAndBookdate += b.booking.bookingNumber + "||";
          });

          var _from = new Date(cartResult.cart.createdDate);
          cartResult._BookingDate = _from.toDateString().substring(4,15);
      }

Process_NameAndPax(booking) {
      // Process Nights and Pax, Merge with Name
      
          var _nights = booking.booking.numberOfDay
          var nightString = _nights + " Night" + (_nights > 1 ? "s":"") + "||";
          
          var _pax:string;
          _pax = booking.booking.adult + " Adult" + (booking.booking.adult > 1 ? "s" : "");
          _pax += booking.booking.child > 0 ? ", " + booking.booking.child + " Child" : "";
          _pax += booking.booking.infant > 0 ? ", " + booking.booking.infant + " Infant" : "";

          var _rooms:string;
          _rooms = "||" + booking.booking.numberOfRooms + " Room" + (booking.booking.numberOfRooms > 1 ? "s" : "");

          booking._NameAndPax = booking.booking.fullname + "||" + nightString + _pax + _rooms;
      }


Process_AmountAndPaymentType(booking)
        // Merge Amount and Payment Type
        {
          var pType: string = "";
          // switch (b.paymentType) {
          //   case 0: pType = 'PayPal'; break;
          //   case 1: pType = 'Bank Transfer'; break;
          //   case 2: pType = 'Union Bank'; break;
          //   case 3: pType = 'Visa'; break;
          // }
          booking._AmountAndPaymentType = this.mathService.RoundUp(parseFloat(booking.booking.totalAmount)) /*.toFixed(2)*/ + "||" + pType;
        }
Process_CartAmountAndPaymentType(cartData)
        // Merge Amount and Payment Type
        {
          var pType: string = "";
          cartData._AmountAndPaymentType = this.mathService.RoundUp(parseFloat(cartData.totalAmount)) /*.toFixed(2)*/ + "||" + pType;
        }

Process_GuestDetails_Payment(booking)
        // Process Name, Contact, and E-mail
        {
          const roomTypeName = booking.bookingDetails?.roomTypeName ?? "[Room Type Unknown]";
          booking._GuestDetails = booking.booking.fullname + "||" + booking.booking.contact + "  |  " + booking.booking.email;// + "||" + b.booking.numberOfRooms + " " + roomTypeName;
        }
Process_CartGuestDetails_Payment(cartData)
        // Process Name, Contact, and E-mail
        {
          cartData._GuestDetails = cartData.bookings[0].booking.fullname + "||" + cartData.bookings[0].booking.contact + "  |  " + cartData.bookings[0].booking.email;// + "||" + b.booking.numberOfRooms + " " + roomTypeName;
        }

Process_BookingDate(booking) {
  // console.log("boking date", booking.booking.bookingDate);
      booking._BookingDate = new Date(booking.booking.bookingDate).toDateString().substring(4,15);
}


table_tourmindbookings = {
    actions: {
      add: false,
      delete: false,
      edit: false,
      position: 'right',
      custom: [
        {
          name: 'edit',
          // title: "<i class='nb-checkmark-circle'></i>",
          title: "Details",
        },
      ],
    },
    columns: {
      _BooknumAndBookdate: {
        title: 'Transaction Number',
        type: 'custom',
        width: '25%',
        renderComponent: MultipleCellContentComponent,
      },
      _NameAndPax: {
        title: 'Guest Name',
        type: 'custom',
        renderComponent: MultipleCellContentComponent,
      },
      _BranchNameAndCheckin: {
        title: 'Hotel',
        type: 'custom',
        renderComponent: MultipleCellContentComponent,
      },
      _AmountAndPaymentType: {
        title: 'Tourmind Price',
        width: '15%',
        type: 'custom',
        renderComponent: MultipleCellContentComponent,
      },
      _TotalPrice: {
        title: 'Booking Price',
        width: '15%',
        type: 'custom',
        renderComponent: MultipleCellContentComponent,
      },
    },
  }
  
  table_tourmindpayment = {
    actions: {
      add: false,
      delete: false,
      edit: false,
    },
    columns: {
      _paymentDate: {
        title: 'Payment Date',
        type: 'string',
      },
      paymentSource: {
        title: 'Payment Source',
        type: 'string',
      },
      referenceNumber: {
        title: 'Ref. Number',
        type: 'string',
      },
      amountPaid: {
        title: 'Amount Paid',
        type: 'string',
      },
      convenienceFee: {
        title: 'Convenience Fee',
        type: 'string',
      },
      _status: {
        title: 'Status',
        type: 'string',
      },
    },
  }

  Process_tourmindbookings(booking) {
        // Process Booking Date, Merge with Booking Number
        {
          booking.jsonParameter = JSON.parse(booking.jsonParameter)
          // b.jsonResponse = JSON.parse(b.jsonResponse)
          booking.booking.costBreakDown = JSON.parse(booking.booking.costBreakDown)
          var _bookingDate = new Date(booking.booking.bookingDate);
          booking._bookingDate = _bookingDate.toDateString() + "\n";

          booking._BooknumAndBookdate = booking.jsonParameter.RequestHeader.TransactionID + "|| Booked: " + booking._bookingDate;
        }

        // Get Hotel name 
        {

          booking._BranchNameAndCheckin = (booking.bookingDetails ? booking.bookingDetails.branchName : '') + "||" + (booking.bookingDetails ? booking.bookingDetails.roomTypeName : '');
        }

        // Process Nights and Pax, Merge with Name, and check in/out
        {
          var _nights = booking.booking.numberOfDay
          var nightString = _nights + " Night" + (_nights > 1 ? "s":"") + " | ";
          
          var _pax:string;
          _pax = booking.booking.adult + " Adult";
          _pax += booking.booking.child > 0 ? ", " + booking.booking.child + " Child" : "";
          _pax += booking.booking.infant > 0 ? ", " + booking.booking.infant + " Infant" : "";
          
          var _from = new Date(booking.booking.bookFrom);
          var _to = new Date(booking.booking.bookTo);
          booking._bookFrom = _from.toDateString() + "\n";
          booking._bookTo = _to.toDateString() + "\n";

          booking._NameAndPax = booking.booking.fullname + "||" + nightString + _pax + "|| Check-in: " + booking._bookFrom + " - " + booking._bookTo;
        }

        // Merge Amount and Payment Type
        {
          var pType: string = "";
          // switch (b.paymentType) {
          //   case 0: pType = 'PayPal'; break;
          //   case 1: pType = 'Bank Transfer'; break;
          //   case 2: pType = 'Union Bank'; break;
          //   case 3: pType = 'Visa'; break;
          // }
          booking._CurrencyCode = booking.jsonParameter.CurrencyCode
          booking._AmountAndPaymentType = this.mathService.RoundUp(parseFloat(booking.booking.totalAmount_Tourmind)) + "||" + booking._CurrencyCode;
          booking._TotalPrice = this.mathService.RoundUp(parseFloat(booking.booking.totalAmount)) + "||PHP" 
        }

        //Set Status
        {

          booking.status === 0 ? booking._status = 'Pending' : booking.status === 1 ? booking._status = 'Confirmed' : booking.status === -1 ? booking._status = 'Failed' : booking._status = 'Unknown'
        }
  }

}


